import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSafeThemeClasses } from '@/shared/theme';
import { useLogout } from '@/features/user/operations/useLogout';
import { ROUTES } from '@/shared/config';

export default function LogoutPage() {
  const navigate = useNavigate();
  const theme = useSafeThemeClasses();
  const { logout } = useLogout();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;

    logout();

    // Redirect to the home page after 3 seconds
    const timer = setTimeout(() => {
      navigate(ROUTES.HOME);
    }, 3000);

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, [navigate, logout]);

  return (
    <div className={`flex items-center justify-center min-h-screen ${theme.background}`}>
      {/* Background decoration */}
      <div className='absolute inset-0 overflow-hidden'>
        <div className={`absolute -top-40 -right-40 w-80 h-80 rounded-full blur-3xl ${theme.orbs[0]}`}></div>
        <div className={`absolute -bottom-40 -left-40 w-80 h-80 rounded-full blur-3xl ${theme.orbs[1]}`}></div>
      </div>

      <div className={`text-center p-8 rounded-2xl ${theme.card} relative z-10`}>
        <h1 className={`text-4xl font-bold mb-4 ${theme.textHeading}`}>Successfully Logged Out!</h1>
        <p className={`text-lg ${theme.textSecondary}`}>Redirecting you to the home page...</p>
        <div className="mt-6">
          <div className={`loading loading-spinner loading-lg ${theme.textAccent}`}></div>
        </div>
      </div>
    </div>
  );
}
